import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import api from 'src/utils/ajax';

interface Assessment {
  id: string;
  name: string;
}

interface AssessmentFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

export const AssessmentFilter: React.FC<AssessmentFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const { data: assessments = [] } = useQuery({
    queryKey: ['assessments'],

    queryFn: async () => {
      const response = await api.get('/api/v2/assessments', {
        params: {
          fetch_all: true,
          pluck_columns: 'id,name',
          'q[s]': 'name asc',
        },
      });
      return response.data;
    },
  });

  const selectedAssessment = assessments.find((a) => a.id === value);

  if (valueOnly) {
    return <>{selectedAssessment?.name || ''}</>;
  }

  return (
    <Autocomplete
      options={assessments}
      getOptionLabel={(option: Assessment) => option.name}
      value={selectedAssessment || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Assessment" />
      )}
    />
  );
};
